module.exports = __webpack_public_path__ + "static/media/Dashboard.7647b4c2.svg";